import { IMAGES_MOBILE, IMAGES_DESKTOP } from '../elements/assets'
import { BUTTON, BUTTON_SETTINGS, BUTTON_SETTINGS_2 } from '../elements/link'
import { LOTTIE_VISUAL } from '../elements/lottie'
import { CONVERSATION_BOX } from '../elements/conversationBox'
import { LOGO_GARDEN_CONTENT } from './logoGarden'

export const HERO_SECTION_V3 = `
...on heroSectionV3_Entry {
  id
  typeHandle

  heading {
    html
    plainText
  }
    
  ${ BUTTON }
  ${ BUTTON_SETTINGS }

  button2 {
    url
    title
  }
  ${ BUTTON_SETTINGS_2 }

  ${ IMAGES_DESKTOP }
  ${ IMAGES_MOBILE }
  ${ LOTTIE_VISUAL }
  ${ CONVERSATION_BOX }


  ${ LOGO_GARDEN_CONTENT }

  heroWidth
  logoGardenWidth
}
`
